import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "title", "captionTop", "caption", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { forwardRef, useState, useCallback, useMemo } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
var IconPassword = function IconPassword(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".icon_password_svg", `{`, "fill:#666666;", `}`]
    }), /*#__PURE__*/_jsx("path", {
      className: "icon_password_svg",
      d: "M12.3,7.3V5.5c0,0,0-0.1,0-0.1C12.3,2.4,9.9,0.1,7,0h0C4.1,0.1,1.7,2.4,1.7,5.3c0,0.1,0,0.1,0,0.2v1.9 C0.8,7.4,0,8.1,0,9v7.3c0,1,0.8,1.7,1.8,1.7h10.5c1,0,1.7-0.7,1.8-1.7V9C14,8.1,13.2,7.4,12.3,7.3L12.3,7.3L12.3,7.3z M3,5.2 c0,0,0-0.1,0-0.1c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4c0,0,0,0.1,0,0.1v2.2H3V5.2z M12.8,16.2c0,0.4-0.3,0.7-0.7,0.7H1.9 c-0.4,0-0.7-0.3-0.7-0.7v-7c0-0.4,0.3-0.7,0.7-0.7h10.1c0.4,0,0.7,0.3,0.7,0.7l0,0L12.8,16.2z"
    }), /*#__PURE__*/_jsx("path", {
      className: "icon_password_svg",
      d: "M8.7,11.8L8.7,11.8c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7c0,0.7,0.5,1.4,1.2,1.6h0v1.3c0,0.3,0.3,0.6,0.6,0.6 l0,0c0.3,0,0.6-0.2,0.6-0.6v-1.3C8.3,13.2,8.7,12.6,8.7,11.8L8.7,11.8L8.7,11.8L8.7,11.8z M7,12.4c-0.3,0-0.6-0.3-0.6-0.6 c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6l0,0C7.6,12.2,7.3,12.5,7,12.4L7,12.4z"
    })]
  }));
};
IconPassword.defaultProps = {
  viewBox: "0 0 14 18"
};
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};
IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
const PasswordField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      title,
      captionTop,
      caption,
      required
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const [on, off] = usePreventContextMenu();
  const {
    0: toggleState,
    1: setToggleState
  } = useState(false);
  const handleClick = useCallback(() => {
    setToggleState(!toggleState);
  }, [toggleState]);
  const inputType = useMemo(() => {
    if (toggleState) return "text";
    if (!toggleState) return "password";
  }, [toggleState]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required
      }),
      children: title
    }), captionTop && /*#__PURE__*/_jsx("p", {
      className: styles.textInputCaption,
      children: captionTop
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.hiddenPass,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        type: inputType,
        name: "password",
        className: classnames(styles.textInput, styles.passwordInput, className, {
          [styles.error]: error
        }),
        defaultValue: "",
        required: required,
        onFocus: off,
        onBlur: on
      }, _props)), /*#__PURE__*/_jsx("span", {
        className: styles.iconPassword,
        children: /*#__PURE__*/_jsx(IconPassword, {})
      }), /*#__PURE__*/_jsx("span", {
        className: classnames(styles.passwordTogle, {
          [styles.eyeOff]: toggleState
        }),
        onClick: handleClick
      })]
    }), caption && /*#__PURE__*/_jsxs("p", {
      className: styles.caption,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), caption]
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
PasswordField.displayName = "PasswordField";
export default PasswordField;